import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { GeneralUtilsService } from 'src/app/_services/general.utils.service';
import {OrderItemsUtilsService} from "../order-items/order-items-util.service";

import * as _ from 'lodash';
import dayjs from 'dayjs';

@Injectable({
	providedIn: 'root'
})
export class OrderHistoryService {

	constructor(
		public appService: AppService,
		public generalUtils: GeneralUtilsService,
		public orderUtils: OrderItemsUtilsService,
	) {}

	restoreBasket($storage) {
		const cacheBasket = localStorage.getItem('basketCache');
		if (cacheBasket) {
			try {
				let basketCache = JSON.parse(cacheBasket);
				if (basketCache.siteId != this.appService.getOrganization()) return;
				if (dayjs().diff(basketCache.date, 'minutes') > 60) {
					if (this.appService.appConfig.isDev) {
						console.error('Ignoring cached basket time limit in dev mode');
					} else {
						return false;
					}
				}

				let historyFolder = $storage.catalog.userOffers;
				basketCache.basket.forEach(o => {
					o.quantity = 1;
					let viewMember = $storage.catalog.tmpViewOffers[o.offer];
					if (viewMember) {

						o._disabled = viewMember._disabled;
						o.stockDisabled = viewMember.stockDisabled;
						o.isBasketOffer = true;
						o.enableQuickAdd = false;

						this.fixedCachedBasket(o);

						historyFolder.push({
							offer: viewMember.offer,
							//member: o,
							preSelection: o
						});

						return true;
					}
				});
			} catch (e) { }
		}
	}

	fixedCachedBasket(offer) {
		let members = _.get(offer,'wizard[0].members');
		if (members){
			offer.wizard[0].members = members.map(group => {
				let reffGroup;
				if (group.modifierGroup) {
					reffGroup = offer._item?.modifierGroups.find(o => o.modifierGroup == group.modifierGroup);
				}else if (group.itemGroup) {
					reffGroup = offer._offer?.selectionGroups.find(o => o.itemGroup == group.itemGroup);
				}
				if (reffGroup) return reffGroup;
				return group;
			});
		}
	}

	//---------------------------------------------------------------->
	//---------------------------------------------------------------->

	async restoreOrder($storage, historicOrder) {
		let basket = [];
		let messages = []
		_.each(historicOrder.orderedOffers, (orderOffer, _index) => {

			const catalogMember: any = $storage.catalog.tmpViewOffers[orderOffer.offer];
			if (!catalogMember) {
				_addMessage(this.appService.translate('TD.offer_not_available', {name: orderOffer.name}));
				return;
			}
			if (catalogMember.disabled) {
				_addMessage(this.appService.translate('TD.offer_not_available', {name: orderOffer.name}));
				return;
			}

			if (!orderOffer._prepared) {
				orderOffer.orderedItems = orderOffer.orderedItems.map(orderItemId => {
					return historicOrder.orderedItems.find(o => o._id === orderItemId);
				});
				orderOffer._prepared = true;
			}

			const selection: any = this.getOfferPreSelection($storage, orderOffer, catalogMember);
			if (!selection) {
				_addMessage(this.appService.translate('TD.offer_not_available', {name: orderOffer.name}));
				return;
			}
			let isSame = false;

			for (let found of basket) {
				if (this.isEqualOffers(selection, found)) {
					++found.quantity;
					isSame = true;
					break;
				}
			}
			if (!isSame) {
				selection.quantity = 1
				basket.push(selection);
			}

		});
		if (messages.length > 0) {
			let canContinue = false;
			await this.appService.confirm({html:this.appService.translate('TD.offers_not_matched',{offers:messages.join('<br>')})}).then(() => {
				canContinue = true;
			}).catch(err => {
				throw {type: 'CANCELED', error: err};
			});
		}
		return basket;

		function _addMessage(message) {
			if (!messages.includes(message)) {messages.push(message);}
		}
	}

	//---------------------------------------------------------------->
	//---------------------------------------------------------------->

	prepareHistoryFolder($storage, favoriteOffers) {
		let historyFolder = $storage.catalog.userOffers;
		_.each(favoriteOffers, (favoriteOffer, _index) => {
			if (historyFolder?.length == 10) return false;
			const catalogMember: any = $storage.catalog.tmpViewOffers[favoriteOffer.offer];
			if (catalogMember) {
				if (catalogMember.disabled) return false;
				const selection: any = this.getOfferPreSelection($storage, favoriteOffer, catalogMember);
				if (!selection) return;
				let isSame = false;

				for (let found of historyFolder) {
					if (this.isEqualOffers(selection, found.preSelection)) {
						isSame = true;
						break;
					}
				}

				if (!isSame) {
					selection.isPreSelection = true;
					let newOffer = {
						isBasketOffer: true,
						enableQuickAdd: false,
						offerId: catalogMember.offer,
						offer: catalogMember.offer,
						member: catalogMember,
						preSelection: selection
					}
					historyFolder.push(newOffer);
				}
			}
		});
	}

	isEqualOffers(offer, reff) {
		return 	_.isEqual(offer.offer, reff.offer) &&
		_.isEqual(offer?._item?.summary, reff._item?.summary) &&
		_.isEqual(offer.selectionSummary, reff.selectionSummary) &&
		_.isEqual(offer.offerRemrks, reff.offerRemrks)
	}

	getFixedOffer(catalog, _roffer) {
		let roffer = _.cloneDeep(_roffer);
		this.orderUtils.prepareViewItem(catalog, roffer);
		this.orderUtils.prepareSelectItem(catalog, roffer);
		if (!roffer.total) roffer.total = roffer.price;
		return roffer;
	}

	getOfferPreSelection($storage, offer, _roffer) {
		let that = this;
		let catalog = $storage.catalog;
		let INV = catalog.inventory;

		if (!_roffer || _roffer.isWeight || _roffer.$$disabled || _roffer.stockDisabled) return false;
		let roffer = this.getFixedOffer(catalog, _roffer)

		_.each(offer.orderedItems, function (_item) {
			if (_item.item && INV[_item.item]) return;

			let itemMatch = that.findOfferItem($storage, roffer, _item.item, _item.itemGroup);
			if (!itemMatch) return;

			let ritem = itemMatch.item, addPrice = 0;

			let selectedModifiers = {};
			let removedModifiers = {};

			_.each(_item.selectedModifiers, mod => {
				let match = selectedModifiers?.[mod?.modifier];
				if (match) match.count += 1;
				else {
					mod.count = 1;
					selectedModifiers[mod.modifier] = mod;
				}

				if (mod.selectedModifiers) { // decisions
					if (!selectedModifiers[mod.modifier]?.decisions) {
						selectedModifiers[mod.modifier].decisions = [];
					}
					_.each(mod.selectedModifiers, decision => {
						selectedModifiers[mod.modifier].decisions[decision.modifierGroup] = decision;
					});
				}
			});

			_.each(_item.removedModifiers, mod => {
				let match = removedModifiers?.[mod?.modifier];
				if (match) match.count += 1;
				else {
					mod.count = 0;
					removedModifiers[mod.modifier] = mod;
				}
			});

			_.each(ritem.modifierGroups, function (rmg) {
				let checkModifiers = false;
				_.each(rmg.modifiers, function (mod) {
					if (rmg.singleSelection) {
						delete mod._selected;
					} else {
						delete mod.formationUnit;
					}

					const removedMatch = removedModifiers?.[mod?._id];

					if (removedMatch) {
						if (!mod.item || !INV[mod.item]) {
							mod._selected = false;
							if (!rmg.removedModifiers) {
								mod.count = 0;
							}
						}
					}
					const match = selectedModifiers?.[mod?._id];
					if (match) {
						if (!mod.item || !INV[mod.item]) {
							mod._selected = true;
							if (!rmg.singleSelection) {
								mod.formationUnit = match.formationUnit;
								mod.count = match.count;
								if (mod.price) {
									addPrice += mod.price * mod.count;
								}
							}
						}

						if (match.decisions) {
							const refItem: any = _.find(catalog.items, { "_id": mod.item });
							if (refItem) {
								mod._item = _.cloneDeep(refItem);
								that.orderUtils.prepareItem(catalog, mod._item, {});
								mod._enableEdit = mod._item._enableEdit;
								mod._selected = true;
								checkModifiers = true;

								if (mod._item?.modifierGroups) {
									_.each(mod._item.modifierGroups, function (m) {
										const matchedDecision = match.decisions[m.modifierGroup];
										if (matchedDecision) {
											const decision = _.find(m.modifiers, { "_id": matchedDecision.modifier });
											if (decision) {
												decision._selected = true;
												mod._itemPrepared = true;
												mod._enableEdit = mod._item._enableEdit;
												that.orderUtils.prepareItemSummary(mod._item, true);
											}
										}
									});
								}
							}
						}
					}
				});
				if (checkModifiers) that.checkModifierGroupSelection(rmg);
			});

			if (itemMatch.type == 'ig') {
				let newTotal = ritem.total || 0;
				ritem._total = ritem.total;
				roffer.total += newTotal;
				ritem.oldTotal = newTotal;
			}
			roffer.total += addPrice;
			roffer.quantity = 1;
			// Added offer notes from history
			if (_item.note && _.get($storage.config.settings, 'enableOfferRemrks', false)) roffer.offerRemrks = _item.note;
		});

		that.orderUtils.prepareOfferSummary(roffer, true);
		const isMatched = this.checkIfModifiersRemoved(offer.orderedItems, roffer);
		if (isMatched) return roffer;

		roffer = _.cloneDeep(_roffer);
		this.orderUtils.prepareViewItem(catalog, roffer);
		roffer.isMatchedToOriginModifier = false;
		return roffer;
	}

	findOfferItem($storage,roffer, _id, itemGroupId?, skipMainItem?) {
		let catalog = $storage.catalog;
		var _arr1;
		// The main item won't have an itemGroup
		if (!skipMainItem) {
			if (roffer?._item?._id == _id) return {
				type: 'main',
				item: roffer._item
			}
		}
		if (roffer?._offer?.selectionGroups) {
			var _arr1 = roffer._offer.selectionGroups;
			for (var i = 0; i < _arr1.length; i++) {
				if (itemGroupId && _arr1[i].itemGroup == itemGroupId) {
					var match = _.find(_arr1[i].items, { _id: _id });
					if (match) {
						if (match.count) { //multiple same item from groups selected
							match.count += 1;
							return {
								type: 'ig',
								member: match,
								item: match._item
							};
						}

						match._selected = true;
						match.count = 1;

						this.orderUtils.prepareItem(catalog, match._item, roffer);
						return {
							type: 'ig',
							member: match,
							item: match._item
						}
					}
				}
			}
		}
	}

	checkModifierGroupSelection(group, preselection?: any) {
		let min = group.min;
		if (min && min > 0) {
			let count = 0;
			_.each(group.modifiers, function (elem) {
				if (elem.formationUnit != null) {
					count += elem.count;
					return true;
				}
			});
			if (count < min) {
				group._requiered = true;
				group._visible = true;
				return true;
			}
			if (count > 0 && min > 0 && preselection?._id) {
				group._requiered = true;
				group._visible = true;
				return true;
			}
		}
		delete group._requiered;
		return false;
	}

	checkIfItemExists(orderedItem, roffer) {
		const { itemGroup, item } = orderedItem;
		const { selectionGroups, items } = roffer._offer;

		if (itemGroup) {
			const group = selectionGroups.find(group => group?.itemGroup === itemGroup);
			return group ? group.items.some(i => i._id === item) : false;
		}

		return items.includes(item);
	}

	checkIfModifiersRemoved(orderedItems = [], roffer) {
		for (const orderedItem of orderedItems) {
			const checkModifiers = (modifiers) => {
				return modifiers?.some(modifier => {
					const modifierId = modifier.modifier;
					const modifierGroupId = modifier.modifierGroup;
					const notMatched = !this.findModifier(modifierGroupId, modifierId, roffer);
					if (notMatched) {
						console.log(`orderedItem: ${orderedItem?.name} notMatched - modifier Group Name: ${modifier?.modifierGroupName}, modifierName: ${modifier?.name}`);
					}
					return notMatched;
				});
			};

			if (!this.checkIfItemExists(orderedItem, roffer)) {
				return false; // Return early if an item doesn't match
			}

			if (orderedItem?.removedModifiers && checkModifiers(orderedItem.removedModifiers)) {
				return false; // Return early if a removed modifier doesn't match
			}

			if (orderedItem?.selectedModifiers && checkModifiers(orderedItem.selectedModifiers)) {
				return false; // Return early if a selected modifier doesn't match
			}
		}

		return true; // All checks passed
	}


	findModifier(modifierGroupId, modifierId, roffer) {
		const modifierGroup = roffer?._item?.modifierGroups?.find(group => group.modifierGroup === modifierGroupId);
		if (modifierGroup) {
			const modifier = modifierGroup.modifiers.find(mod => mod._id === modifierId);
			return modifier ? true : false;
		}
		return false;
	}

}
